import { render } from "./SelecionarCest.vue?vue&type=template&id=6f4219f7&ts=true"
import script from "./SelecionarCest.vue?vue&type=script&lang=ts"
export * from "./SelecionarCest.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__